import { Reducer } from "redux";
import { TicketListItem } from "../../models/ticket/TicketListItem";
import { GetLatestTicketTransactionsActionTypes, GetTicketTransactionsActionTypes } from "./types";

export interface TicketState {
    transactions?: TicketListItem[];
    latestTransactions?: TicketListItem[];
}

const unloadedState: TicketState = { transactions: undefined, latestTransactions: undefined };

export const ticketReducer: Reducer<TicketState> = (state: TicketState | undefined, action): TicketState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case GetTicketTransactionsActionTypes.SUCCESS:
            return { ...state, transactions: [...action.payload] };
        case GetLatestTicketTransactionsActionTypes.SUCCESS:
            return { ...state, latestTransactions: [...action.payload] };
        default:
            return state;
    }
};
